import { render, staticRenderFns } from "./appdev.vue?vue&type=template&id=c173a070&scoped=true"
import script from "./appdev.vue?vue&type=script&lang=js"
export * from "./appdev.vue?vue&type=script&lang=js"
import style0 from "./appdev.vue?vue&type=style&index=0&id=c173a070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c173a070",
  null
  
)

export default component.exports